import { useEffect } from 'react';

type Options = {
    language?: string;
}

export function useDirection(options: Options | null) {
    useEffect(() => {
        if (!options) return;

        let dir = 'ltr';
        switch (options?.language) {
            case 'he':
            case 'ar':
                dir = 'rtl';
                break;
            default:
                dir = 'ltr';
                break;
        }
        document.body.setAttribute('dir', dir);
    }, [options]);
}